import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

export const HistogramStyle = styled.div`
  padding: 8px 32px 72px 96px;
  width: 100%;

  .histogram-container {
    border-bottom: solid 1px ${colors.grayishBlue};
    border-left: solid 1px ${colors.grayishBlue};
    padding-left: 16px;
    position: relative;
    width: 100%;

    svg {
      display: block;
      height: auto;
      width: 100%;
    }

    .chart-grades {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.black};
      font-size: 14px;
      line-height: 16px;
      position: absolute;

      &:after {
        background-color: ${colors.grayishBlue};
        content: '';
        display: block;
        position: absolute;
      }

      &.grade-x {
        bottom: 0;
        padding-top: 4px;
        transform: translate(-50%, 100%);

        &:after {
          height: 5px;
          left: 50%;
          position: absolute;
          top: 0;
          transform: translate(-50%, -4px);
          width: 1px;
        }
      }

      &.grade-y {
        left: 0;
        padding-right: 6px;
        transform: translate(-100%, 50%);

        &.first-grade-y {
          &:after {
            display: none;
          }
        }

        &:after {
          height: 1px;
          right: 0;
          top: 50%;
          transform: translate(4px, -50%);
          width: 5px;
        }
      }
    }
  }
`;
